export default __webpack_public_path__ + "static/media/bg.4f2fdc9b.svg";